import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SupplierRegistrationComponent } from 'src/app/front-user/services/e-tender/supplier-registration/supplier-registration.component';
import { SupplierRegistrationAprovalComponent } from '../supplier-registration-aproval/supplier-registration-aproval.component';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Languages, ApprovalLevel } from 'src/app/shared/models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
@Component({
  selector: 'app-technical-category-admin-aproval',
  templateUrl: './technical-category-admin-aproval.component.html',
  styles: []
})
export class TechnicalCategoryAdminAprovalComponent implements OnInit, AfterViewInit {
  //#region PROPERTIES
  /////////////////////*Input - Outputs -ViewChild*/////////////////////
  @ViewChild('supplierChild',{static: false}) supplierChild: SupplierRegistrationComponent;
  @ViewChild('technicalApprovalChild',{static: false}) technicalApprovalChild: SupplierRegistrationAprovalComponent;
  /////////////////////*Language*/////////////////////
  public Languages: any = Languages;
  public currentLanguage: any;
  isSubmitSucceededEvent: boolean = false;
  public selectedSupplierId: string;
  public approvalLevel: ApprovalLevel = ApprovalLevel.Technical;
  private currentUser: User = new User();
  wfAppInstanceId: string;
  baseRequestId: string;
  categoryId: string;
  public isRequestHistory: boolean = false;
  private isInActivateStepInput: boolean = false;
  //#endregion
  //#region CONSTRUCTOR
  constructor(
    private globalServices: GlobalServices,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.isInActivateStepInput = false;
    this.currentLanguage = this.globalServices.getLanguage();
    this.currentUser = this.globalServices.user;
    if (history.state.data) {
      if (history.state.data.requestId) {
        this.selectedSupplierId = history.state.data.requestId;
        //TODO: Get the AppInistanceID_CategoryID from MyTasks to be sent as InPut in approval Component
        //TODO: Get [AppInstanceID-CategoryId] -  from my tasks as "BaseRequestID_CategoryID"
        this.wfAppInstanceId = history.state.data.appInstanceId;
        var splits = this.wfAppInstanceId.split("_")
        this.baseRequestId = splits[0];
        this.categoryId = splits[1];
      }
      if (history.state.data.isCompleted) {
        this.isRequestHistory = history.state.data.isCompleted;
      }
    }
    else {
      // this.globalServices.goToHome();
      //  this.router.navigate(['RebateRequest/AccurateDataForm'], { state: { data: { requestId: this.rebateRequestId } } });
      //   this.selectedSupplierId = "E26FBBE8-7677-4C85-83D2-DD2C54894ADF"
      //   this.wfAppInstanceId = "d58c27d2-3c7f-4fb4-ac6a-35ac78bc1713_1";
      //   var splits = this.wfAppInstanceId.split("_")
      //   this.baseRequestId = splits[0];
      //   this.categoryId = splits[1];
    }
  }
  //#endregion
  //#region EVENTS
  ngOnInit() {

  }
  ngAfterViewInit(): void {

  }
  receiveIsSubmitSucceededEvent($event) {
    this.isSubmitSucceededEvent = $event;
  }
  //#endregion
}
